<template>
  <div> 
    <NavBar/>
    <div class="container main-container">
      <OrderList
        v-bind:orders="$store.state.orders" 
        v-bind:type="'MY_ORDERS'"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderList from "../components/OrderList"
import NavBar from "../components/NavBar"

export default {
  name: 'orders',
  props: ['orders'],
  created() {
    this.getOrders()
  },
  components: {
    OrderList,
    NavBar,
  },
  methods: {
    getOrders: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      this.$http
        .post(url + "orders", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          this.$store.commit("updateLaundryOrders", result.body.result.orders);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    },
  },
  data: function() {
      return {
    }
  }
}
</script>

<style>
</style>
